import { FlexCentreAlign } from 'approot/shared/styles/flex.style';
import { AnswerSheetSaveStatus } from '../answer-save-status/answer-save-status';
import { ActivitySheetCloseButton } from './activity-sheet';

type Props = {
  title: string;
  showStatus?: boolean;
  onClose: () => void;
};

const ActivitySheetSaveStatus = ({
  title,
  showStatus = true,
  onClose,
}: Props) => {
  return (
    <>
      {showStatus && (
        <FlexCentreAlign>
          <AnswerSheetSaveStatus />
        </FlexCentreAlign>
      )}
      <ActivitySheetCloseButton title={title} onClose={onClose} />
    </>
  );
};

export default ActivitySheetSaveStatus;
